export const refLayersToInclude = {
  whaleDolphin: [
    {
      layer: "Whale and Dolphin Watching Operators",
      tooltip:
        "Locations of charter vessel operators offering whale/dolphin watching tours based on data from TripAdvisor and local directory listings provided by TNC Caribbean Division.",
      measurement: "",
    },
    {
      layer: "Population Analysis - Number of People",
      title: "Number of People per 90 square meters",
      tooltip:
        "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
      link: "www.dataforgood.fb.com/tools/population-density-maps",
      measurement: "",
      sublayers: [
        {
          id: 332,
          visible: false,
        },
        {
          id: 333,
          visible: false,
        },
        {
          id: 334,
          visible: false,
        },
        {
          id: 335,
          visible: true,
        },
      ],
      isRaster: true,
    },
    {
      layer: "Population Analysis - Number of Women",
      title: "Number of Women per 90 square meters",
      tooltip:
        "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
      link: "www.dataforgood.fb.com/tools/population-density-maps",
      measurement: "",
      sublayers: [
        {
          id: 332,
          visible: false,
        },
        {
          id: 333,
          visible: false,
        },
        {
          id: 334,
          visible: true,
        },
        {
          id: 335,
          visible: false,
        },
      ],
      isRaster: true,
    },
    {
      layer: "Population Analysis - Number of Elderly",
      title: "Number of Elderly (over 60 years old) per 90 square meters",
      tooltip:
        "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
      link: "www.dataforgood.fb.com/tools/population-density-maps",
      measurement: "",
      sublayers: [
        {
          id: 332,
          visible: false,
        },
        {
          id: 333,
          visible: true,
        },
        {
          id: 334,
          visible: false,
        },
        {
          id: 335,
          visible: false,
        },
      ],
      isRaster: true,
    },
    {
      layer: "Population Analysis - Number of Children",
      title: "Number of Children (under 5 years old) per 90 square meters",
      tooltip:
        "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
      link: "www.dataforgood.fb.com/tools/population-density-maps",
      measurement: "",
      sublayers: [
        {
          id: 332,
          visible: true,
        },
        {
          id: 333,
          visible: false,
        },
        {
          id: 334,
          visible: false,
        },
        {
          id: 335,
          visible: false,
        },
      ],
      isRaster: true,
    },
  ],
  bird: [
    {
      layer: "Birdwatching Hotspots",
      title: "Other birding hotspots",
      isMulti: true,
      tooltip:
        "This points layer includes naturalarea points from extracted from TripAdvisor by TNC using keywords, and BirdsCaribbean’s Caribbean Birding Trail layer. The areas layer was digitized by TNC using in-country contractor provided data using Google Maps, Open Street Map, and TNC Caribbean’s protected area layer as references.",
      measurement: "",
    },
    {
      layer: "Areas of Conservation Importance",
      tooltip:
        "Includes areas from BirdLife International (Important Bird and Biodiversity Area (IBA) digitalboundaries: September 2020 version. BirdLife International, Cambridge, UK) and The Nature Conservancy's Caribbean Protected Area data layer (2020).",
      link: "http://datazone.birdlife.org/home",
      measurement: "",
    },
    {
      layer: "Population Analysis - Number of People",
      title: "Number of People per 90 square meters",
      tooltip:
        "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
      link: "www.dataforgood.fb.com/tools/population-density-maps",
      measurement: "",
      sublayers: [
        {
          id: 332,
          visible: false,
        },
        {
          id: 333,
          visible: false,
        },
        {
          id: 334,
          visible: false,
        },
        {
          id: 335,
          visible: true,
        },
      ],
      isRaster: true,
    },
    {
      layer: "Population Analysis - Number of Women",
      title: "Number of Women per 90 square meters",
      tooltip:
        "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
      link: "www.dataforgood.fb.com/tools/population-density-maps",
      measurement: "",
      sublayers: [
        {
          id: 332,
          visible: false,
        },
        {
          id: 333,
          visible: false,
        },
        {
          id: 334,
          visible: true,
        },
        {
          id: 335,
          visible: false,
        },
      ],
      isRaster: true,
    },
    {
      layer: "Population Analysis - Number of Elderly",
      title: "Number of Elderly (over 60 years old) per 90 square meters",
      tooltip:
        "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
      link: "www.dataforgood.fb.com/tools/population-density-maps",
      measurement: "",
      sublayers: [
        {
          id: 332,
          visible: false,
        },
        {
          id: 333,
          visible: true,
        },
        {
          id: 334,
          visible: false,
        },
        {
          id: 335,
          visible: false,
        },
      ],
      isRaster: true,
    },
    {
      layer: "Population Analysis - Number of Children",
      title: "Number of Children (under 5 years old) per 90 square meters",
      tooltip:
        "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
      link: "www.dataforgood.fb.com/tools/population-density-maps",
      measurement: "",
      sublayers: [
        {
          id: 332,
          visible: true,
        },
        {
          id: 333,
          visible: false,
        },
        {
          id: 334,
          visible: false,
        },
        {
          id: 335,
          visible: false,
        },
      ],
      isRaster: true,
    },
  ],
};

export const WhaleDolphinConfig = {
  stats: {
    large: [
      {
        name: "# of operators",
        title: "# of Recorded Operators",
        tooltip:
          "Estimated number of charter vessel operators offering whale and dolphin watching tours; data derived from TripAdvisor and local directory listing provided by TNC Caribbean Division.",
        measurement: null,
      },
      {
        name: "Estimated annual tourism expenditure (USD)",
        title: "Estimated annual tourism expenditure (USD)",
        tooltip:
          "Estimated based on survey data on costs and number of trips offered per year.",
        measurement: "$",
      },
    ],
    small: [
      {
        name: "EEZ area (sqkm)",
        title: "Total EEZ area",
        tooltip:
          "The total are of the Economic Exclusion Zone. Data are not official, but are taken from the TNC Caribbean Challenge Initiative EEZ statistcs, calculated from the 2018 VLIZ EEZ layer (https://www.marineregions.org/) using a custom Lambert projection centered on the Caribbean.",
        measurement: "(sqkm)",
      },
      {
        name: "% of EEZ used by whale/dolphin tourism",
        title: "% of EEZ used by whale/dolphin tourism",
        tooltip:
          "The area of the recreational fishing footprint divided by the area of the EEZ",
        measurement: null,
      },
    ],
  },
  data: [
    {
      name: "CROP Countries",
      url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Whale_and_Dolphin_Watching_03292021_WFL1/FeatureServer/0",
    },
    {
      name: "Dominica",
      url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Whale_Dolphin_Scaled_per_Country_WFL1/FeatureServer/0",
    },
    {
      name: "Grenada",
      url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Whale_Dolphin_Scaled_per_Country_WFL1/FeatureServer/1",
    },
    {
      name: "Saint Kitts and Nevis",
      url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Whale_and_Dolphin_Watching_03292021_WFL1/FeatureServer/0",
    },
    {
      name: "Saint Lucia",
      url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Whale_Dolphin_Scaled_per_Country_WFL1/FeatureServer/2",
    },
    {
      name: "Saint Vincent and the Grenadines",
      url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Whale_Dolphin_Scaled_per_Country_WFL1/FeatureServer/3",
    },
    {
      name: "Statistics Table",
      url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/arcgis/rest/services/MOWCROP_AppStats_05042021/FeatureServer/0",
    },
  ],
};

export const BirdConfig = {
  stats: [
    {
      name: "Index of birdwatching importance",
      title: "Index of Birdwatching Importance",
      tooltip:
        "An indicator of birdwatching importance to the country's tourism derived by dividing the total number of Birder Observer Days from eBird (defined as one observation per observer per day) divided by the total number of visitors (from ECCB, data averaged over 5 years between 2015 - 2019) and multiplied by 1000.",
      measurement: null,
    },
    {
      name: "Number of Key Species",
      title: "Total # of Key Species",
      tooltip:
        "Key species describe birds that are expected to be of particular interest to birdwatchers, and are defined as birds that are rare, endemic, endangered, or otherwise charismatic.",
      measurement: null,
    },
    {
      name: "Number of Endemic Species",
      title: "Total # of Endemics",
      tooltip:
        "Specifies the number of birds that are endemic to the region (either West Indies, Lesser Antilles, or a specific country) found in this country based on BirdsCaribbean's Birds of the West Indies Checklist. Single island endemics are not given extra weighting.",
      measurement: null,
    },
    {
      name: "Number of Threatened Species",
      title: "Total # of Threatened Species",
      tooltip:
        "Specifies the number of threatened species (Vulnerable, Endangered or Critically Endangered) found in this country based on BirdsCaribbean's Birds of the West Indies Checklist & IUCN Red List of Threatened Species.",
      measurement: null,
    },
    {
      name: "Number of Total Species",
      title: "Total Species",
      tooltip:
        "The total number of bird species observed in the country based on eBird records.",
      measurement: null,
    },
    {
      name: "Birder Footfall",
      title: "Birder Footfall",
      tooltip:
        'Estimate of birdwatching effort, based on data uploaded by users of the internationally popular eBird app. Numbers represent birdwatching intensity, with the score being the sum of "observer-day" uploads per 500m grid cell (ie. capturing only one observation per observer per day per cell).',
      measurement: null,
    },
  ],
  data: [
    {
      name: "Birder Footfall",
      url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Bird_watching_03292021_WFL1/FeatureServer/0",
    },
    {
      name: "Species Importance",
      url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Bird_watching_03292021_WFL1/FeatureServer/1",
    },
    {
      name: "Statistics Table",
      url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/arcgis/rest/services/MOWCROP_AppStats_05042021/FeatureServer/0",
    },
  ],
};

export const ReferenceConfig = {
  whale: [
    {
      url: "https://oceanwealth.org/wp-content/uploads/2021/04/Output_7_Other_Nature_Dependent_Tourism_FINAL_.pdf",
      label: "Technical Report",
    },
    {
      url: "https://oceanwealth.org/wp-content/uploads/2021/06/Whale-Dolphin-Technical-Summary-Draft.pdf",
      label: "Technical Summary",
    },
    {
      url: "https://tnc.box.com/shared/static/0yqljfim75xpsg7hvm9s9ozfxh2knyeh.zip",
      label: "Data Download",
    },
    {
      url: "https://oceanwealth.org/project-areas/caribbean/crop/country-summaries/",
      label: "Country Summary",
    },
  ],

  bird: [
    {
      url: "https://oceanwealth.org/wp-content/uploads/2021/04/Output_7_Other_Nature_Dependent_Tourism_FINAL_.pdf",
      label: "Technical Report",
    },
    {
      url: "https://oceanwealth.org/wp-content/uploads/2021/06/Birdwatching-Technical-Summary.pdf",
      label: "Technical Summary",
    },
    {
      url: "https://tnc.box.com/shared/static/0yqljfim75xpsg7hvm9s9ozfxh2knyeh.zip",
      label: "Data Download",
    },
    {
      url: "https://oceanwealth.org/project-areas/caribbean/crop/country-summaries/",
      label: "Country Summary",
    },
  ],
};
